// ピクセル表面を構成する不変タイル。
//
// タイルは一度作ったら書き換えない。書き換えは常に新しいタイルへの置換で行い、
// 履歴は置換前のタイルへの参照を持つだけ (コピーしない)。これが差分履歴と
// COW (copy-on-write) の土台になる。

export const TILE_SIZE = 256

export type Channels = 1 | 4

export interface Tile {
  readonly data: Uint8ClampedArray
  readonly channels: Channels
}

export function tileKey(tx: number, ty: number): string {
  return `${tx},${ty}`
}

export function parseTileKey(key: string): { tx: number; ty: number } {
  const i = key.indexOf(',')
  return { tx: Number(key.slice(0, i)), ty: Number(key.slice(i + 1)) }
}

export function tileByteLength(channels: Channels): number {
  return TILE_SIZE * TILE_SIZE * channels
}

export function createTile(channels: Channels, data?: Uint8ClampedArray): Tile {
  const expected = tileByteLength(channels)
  if (data && data.length !== expected) {
    throw new Error(`タイルのバイト長が不正: ${data.length} (期待 ${expected})`)
  }
  return { data: data ?? new Uint8ClampedArray(expected), channels }
}

/** タイルが完全に空 (すべて 0) か。透明タイルを Map から落とすために使う */
export function tileIsEmpty(tile: Tile): boolean {
  const d = tile.data
  if (tile.channels === 4) {
    for (let i = 3; i < d.length; i += 4) if (d[i] !== 0) return false
    return true
  }
  for (let i = 0; i < d.length; i++) if (d[i] !== 0) return false
  return true
}
